import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { LayoutStepsClientModule } from '../clients/add-client/layout-steps-client/layout-steps-client.module';

import { LogicielCaisseListToolbarComponent } from './shared/logiciel-caisse-list-toolbar/logiciel-caisse-list-toolbar.component';
import { LogicielCaisseEntrepotsComponent } from './entrepots/logiciel-caisse-entrepots.component';
import { LogicielCaisseCaissesComponent } from './caisses/logiciel-caisse-caisses.component';
import { LogicielCaisseGerantEntrepotComponent } from './gerant-entrepot/logiciel-caisse-gerant-entrepot.component';
import { LogicielCaisseVendeurCaisseComponent } from './vendeur-caisse/logiciel-caisse-vendeur-caisse.component';
import { LogicielCaisseEtablissementsComponent } from './etablissements/logiciel-caisse-etablissements.component';
import { LogicielCaisseTicketTemplatesComponent } from './ticket-templates/logiciel-caisse-ticket-templates.component';
import { LogicielCaisseTypeModePaimentComponent } from './type-mode-paiment/logiciel-caisse-type-mode-paiment.component';
import { LogicielCaisseSetupDashboardComponent } from './setup-dashboard/logiciel-caisse-setup-dashboard.component';
import { LogicielCaisseSetupWizardComponent } from './setup-wizard/logiciel-caisse-setup-wizard.component';
import { LogicielCaisseParametreProgressComponent } from './shared/logiciel-caisse-parametre-progress/logiciel-caisse-parametre-progress.component';

@NgModule({
  declarations: [
    LogicielCaisseListToolbarComponent,
    LogicielCaisseParametreProgressComponent,
    LogicielCaisseEntrepotsComponent,
    LogicielCaisseCaissesComponent,
    LogicielCaisseGerantEntrepotComponent,
    LogicielCaisseVendeurCaisseComponent,
    LogicielCaisseEtablissementsComponent,
    LogicielCaisseTicketTemplatesComponent,
    LogicielCaisseTypeModePaimentComponent,
    LogicielCaisseSetupDashboardComponent,
    LogicielCaisseSetupWizardComponent,
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgSelectModule,
    DragDropModule,
    LayoutStepsClientModule,
  ],
  exports: [
    LogicielCaisseEntrepotsComponent,
    LogicielCaisseCaissesComponent,
    LogicielCaisseGerantEntrepotComponent,
    LogicielCaisseVendeurCaisseComponent,
    LogicielCaisseEtablissementsComponent,
    LogicielCaisseTicketTemplatesComponent,
    LogicielCaisseTypeModePaimentComponent,
    LogicielCaisseSetupDashboardComponent,
    LogicielCaisseSetupWizardComponent,
    LogicielCaisseParametreProgressComponent,
  ],
})
export class LogicielCaisseParametreModule {}
